import { useEffect, useState } from "react";
import { Icon } from '@gplibraries/react/components';
import './InviteModal.scss'


const PERMISSIONS_BY_CODE = {
  "1": "Parts",
  "2": "Wholegoods",
  "3": "Service",
  "4": "Warranty",
  "5": "Sales & Marketing",
  "6": "Credit",
  "9": "Government Contracts",
};


export function InviteModal({ user, isOpen, onClose, onSubmit, mode = 'permissions', dealerInfo }) {
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [selectedCodes, setSelectedCodes] = useState({GP: { enabled: false, codes: {} },LP: { enabled: false, codes: {} },});


  const divisions = Array.isArray(dealerInfo?.divisions) ? dealerInfo.divisions : [];

  const hasGreatPlains = divisions.includes("01");
  const hasLandPride = divisions.includes("02");
  const showBothDivisions = mode === "permissions" || mode === "employeeUsersInUse";
  const showGpOnly = mode === "noAuth";

  const divisionConfig = [
    { code: "01", key: "GP", label: "Great Plains", visible: hasGreatPlains },
    { code: "02", key: "LP", label: "Land Pride", visible: hasLandPride },
  ];

    useEffect(() => {
      if (!isOpen) return;

      setEmail(user?.email ?? "");
      setFullName(user?.name ?? "");

      
      const next = {
        GP: { enabled: false, codes: {} },
        LP: { enabled: false, codes: {} },
      };


      if (user?.permissionsByDivision) {
        if (user.permissionsByDivision.GP) {
          next.GP = {
            enabled: user.permissionsByDivision.GP.enabled,
            codes: { ...user.permissionsByDivision.GP.codes },
          };
        }

        if (user.permissionsByDivision.LP) {
          next.LP = {
            enabled: user.permissionsByDivision.LP.enabled,
            codes: { ...user.permissionsByDivision.LP.codes },
          };
        }
      }

      setSelectedCodes(next);

    }, [isOpen, user, mode, dealerInfo, hasLandPride]);




    if (!isOpen) return null;

    
    const toggleCode = (division, code) => {
      setSelectedCodes((prev) => ({
        ...prev,
        [division]: {
          ...prev[division],
          codes: {
            ...prev[division].codes,
            [code]: !prev[division].codes?.[code],
          },
        },
      }));
    };


    const toggleDivision = (division) => {
      setSelectedCodes((prev) => ({
        ...prev,
        [division]: {
          ...prev[division],
          enabled: !prev[division].enabled,
        },
      }));
    };



  const handleInvite = () => {
    const permissions = [];

    // Great Plains (01)
    if (selectedCodes.GP.enabled) {
      const values = Object.entries(selectedCodes.GP.codes || {})
        .filter(([_, enabled]) => enabled)
        .map(([code]) => code);

      permissions.push({
        division: "01",
        values: values.length > 0 ? values : null, // ✅ avoid empty array
      });
    }

    // Land Pride (02)
    if (selectedCodes.LP.enabled) {
      const values = Object.entries(selectedCodes.LP.codes || {})
        .filter(([_, enabled]) => enabled)
        .map(([code]) => code);

      permissions.push({
        division: "02",
        values: values.length > 0 ? values : null, // ✅ avoid empty array
      });
    }

    onSubmit({
      username: email,
      full_name: fullName,
      permissions,
    });
  };



  return (
    <div className="invite-modal-backdrop" onClick={onClose}>
      <div
        className="invite-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="invite-modal-header">
          <h2>Invite User</h2>
          <button onClick={onClose} className="icon-button">
            <Icon glyph="x-lg" />
          </button>
        </div>

        {/* Body */}
        <div className="invite-modal-body">
          <label className="email-input">
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>

          <label className="full-name-input">
            Full name
            <input value={fullName} onChange={(e) => setFullName(e.target.value)} required />
          </label>   
          {showBothDivisions && (
            <div className="permissions-section">
              {divisionConfig
                .filter((division) => division.visible)
                .map((division) => (
                  <div className="permission-group" key={division.key}>
                    <label className="group-header">
                      <input
                        type="checkbox"
                        checked={selectedCodes[division.key].enabled}
                        onChange={() => toggleDivision(division.key)}
                      />
                      {division.label}
                    </label>

                    {selectedCodes[division.key].enabled && (
                      <div className="permissions-list permissions-list--indented">
                        {Object.entries(PERMISSIONS_BY_CODE).map(([code, label]) => (
                          <label key={`${division.key}-${code}`}>
                            <input
                              type="checkbox"
                              checked={!!selectedCodes[division.key].codes?.[code]}
                              onChange={() => toggleCode(division.key, code)}
                            />
                            {label}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          )}
          {showGpOnly && hasLandPride && (
            <div className="permissions-section">
              <div className="permission-group">
                <div className="group-header">
                  <strong>Permissions for Land Pride</strong>
                </div>

                <div className="permissions-list permissions-list--flat">
                  {Object.entries(PERMISSIONS_BY_CODE).map(([code, label]) => (
                    <label key={code}>
                      <input
                        type="checkbox"
                        checked={!!selectedCodes.LP.codes?.[code]}
                        onChange={() => toggleCode("LP", code)}
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="invite-modal-footer">
          <button
            type="button"
            className="secondary-btn"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            type="button"
            className="primary-btn"
            onClick={handleInvite}
          >
            Invite
          </button>
        </div>
      </div>
    </div>
  );
}